<template>

  <vs-card>
    <div slot="header">
      <div class="d-flex align-items-center justify-content-between">
        <h3 class="m-3">
          Dodatkowe dane podane przez klienta
        </h3>
      </div>
    </div>


  <div :key="q.id" v-for="q in questions">
    <div v-if="['QUESTION_FULL', 'QUESTION_RADIO'].includes(q.type)">
      <div class="d-flex justify-content-between mt-2 pt-2 mb-1 pb-1">
        <p>{{q.title}}</p>
        <div>
          <label class="mr-3">TAK
            <input :checked="info[q.id].checked === true" type="radio" :name="q.id" :value="true" disabled style="color: red"></label>
          <label>NIE
            <input :checked="info[q.id].checked === false" type="radio" :name="q.id" :value="false" disabled></label>
        </div>
      </div>
      <transition name="slide">
        <vs-textarea v-if="q.type === 'QUESTION_FULL'" v-show="info[q.id].checked"
                     rows="3" :label="q.text"
                     :value="info[q.id].answer"
                     disabled
        />
      </transition>

    </div>
    <div v-if="q.type === 'QUESTION_TEXT'">
      <vs-textarea class="mt-5 pt-2 mb-1 pb-1"
                   rows="3" :label="q.text"
                   :value="info[q.id].answer"
                   disabled/>
    </div>
  </div>


  </vs-card>

</template>

<script>
  import { QUESTIONS } from '../../utils/questions';

  export default {
    name: "ClientInfoView",
    props: {
      infoString: {
        type: String,
        required: true
      }
    },
    computed: {
      questions() {
        return QUESTIONS;
      },
      info() {
        return JSON.parse(this.infoString);
      }
    },
  }
</script>

<style scoped>

</style>
